import React, { useEffect, useState, useMemo, useRef, useCallback } from "react";
import * as XLSX from "xlsx";

import AxipaysLogo from "./media/Axipays_logo.webp";
import download from "./media/download.png";
import refresh from "./media/refresh.png";
import arrowDropDownWhite from "./media/arrow-drop-down-white.png";
import close from "./media/close.png";

const Reconciliation = () => {
  const statusOptions = ["Matched", "Not Found", "Amount Mismatch", "Status Mismatch", "Mismatches"];
  const aquirerOptions = ["Neonpay", "Link Payment", "MilkyPay", "Pagora"];
  const exportOptions = ["Aquirer Report", "Centpays settlement", "Settlement Report"];
  const [isLoading, setIsLoading] = useState(false);
  const [transactionsData, setTransactionsData] = useState([]);
  const [aqTransactionsData, setAqTransactionsData] = useState([]);
  const [fetchAcquirerIds, setFetchAcquirerIds] = useState(false);
  const [settlementReport, setSettlementReport] = useState([]);
  const [, setSelectedExportOption] = useState("");
  const [selectedState, setSelectedState] = useState("All");
  const [selectedAquirer, setSelectedAquirer] = useState("Neonpay");
  const [aquirerDropdown, setAquirerDropdown] = useState(false);
  const [exportDropdown, setExportDropdown] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [fromDateInput, setFromDateInput] = useState("");
  const [toDateInput, setToDateInput] = useState("");
  const [txnSelectedStatus, setTxnSelectedStatus] = useState("");
  const [aqSelectedStatus, setAqSelectedStatus] = useState("");
  const [isReconClicked, setIsReconClicked] = useState(false);
  const [isData, setisData] = useState(false);
  const [isAqdata, setisAqdata] = useState(false);
  const [isRedirectedChecked, setIsRedirectedChecked] = useState(false);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [statusDetails, setStatusDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [submitText, setSubmitText] = useState("Submit");
  const [shouldGenerateReport, setShouldGenerateReport] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginTimeoutId, setLoginTimeoutId] = useState(null);
  const [loginData, setLoginData] = useState({ email: "", password: "" });
  const [loginError, setLoginError] = useState("");
  const [showMappingBox, setShowMappingBox] = useState(false);
  const [excelHeaders, setExcelHeaders] = useState([]);
  const [txnIdTrimValue, setTxnIdTrimValue] = useState("");
  const [trimToRemove, setTrimToRemove] = useState("");
  const [search, setSearch] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [mapping, setMapping] = useState({
    transaction_id: [],
    state: [],
    amount: [],
    currency: [],
    status: []
  });
  const [multiSelectEnabled, setMultiSelectEnabled] = useState({
    transaction_id: false,
    amount: false,
    currency: false,
    status: false
  });


  const fileInputRef = useRef();
  const [formData, setFormData] = useState({
    acquirer: "",
    traffic_type: "",
    currency: "",
    mdr: "",
    approval_fee: "",
    decline_fee: "",
    rr: "",
    settlement_fee: "",
    password: ""
  });

  const [rates, setRates] = useState({
    mdr: "",
    rr: "",
    app_fee: "",
    dec_fee: "",
    sett_fee: ""
  });

  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  const formatNumber = (num) => Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };

  const handleLogin = () => {
    const correctEmail = "admin@axipays.com";
    const correctPassword = "Admin@axipays2025";

    if (loginData.email === correctEmail && loginData.password === correctPassword) {
      setIsAuthenticated(true);
      setLoginError("");
      localStorage.setItem("loginTime", Date.now().toString());

      const timeout = setTimeout(() => {
        setIsAuthenticated(false);
        setLoginData({ email: "", password: "" });
        localStorage.removeItem("loginTime");
        alert("Session expired. Please log in again.");
      }, 90 * 60 * 1000);

      setLoginTimeoutId(timeout);
    } else {
      setLoginError("Invalid email or password.");
    }
  };

  useEffect(() => {
    return () => {
      if (loginTimeoutId) clearTimeout(loginTimeoutId);
    };
  }, [loginTimeoutId]);

  useEffect(() => {
    const loginTime = localStorage.getItem("loginTime");
    if (loginTime) {
      const elapsed = Date.now() - parseInt(loginTime, 10);
      if (elapsed < 30 * 60 * 1000) {
        setIsAuthenticated(true);
        const remaining = 30 * 60 * 1000 - elapsed;
        const timeout = setTimeout(() => {
          setIsAuthenticated(false);
          localStorage.removeItem("loginTime");
          alert("Session expired. Please log in again.");
        }, remaining);
        setLoginTimeoutId(timeout);
      } else {
        localStorage.removeItem("loginTime");
      }
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
        setAquirerDropdown(false);
        setExportDropdown(false);
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleRefresh = () => {
    handleFetchReconciliation();
    setSelectedAquirer("Neonpay");
  };

  const handleClear = () => {
    setFromDateInput("");
    setToDateInput("");
    setSelectedAquirer("Neonpay");
    setTransactionsData([]);
    setAqTransactionsData([]);
    setSettlementReport([]);
    setIsReconClicked(false);
    setisAqdata(false);
    setisData(false);
    setIsRedirectedChecked(false);
    setAqSelectedStatus("");
    setTxnSelectedStatus("")
  };

  const totalFinalSettlementAmount = settlementReport.reduce(
    (sum, row) => sum + parseFloat(row.finalsettlementAmount || 0),
    0
  );

  const filteredTransactionsData = useMemo(() => {
    return transactionsData.filter((txn) => {
      let stateMatch = selectedState === "All" || txn.state === selectedState;
      if (selectedState === "Mismatches") {
        stateMatch = txn.state !== "Matched" &&
          (txn.state === "Not Found" || txn.state === "Amount Mismatch" || txn.state === "Status Mismatch");
      }
      const statusMatch = !txnSelectedStatus || txn.status.toLowerCase() === txnSelectedStatus.toLowerCase();
      const redirectedMatch = !isRedirectedChecked || txn.is_redirected === true;
      return stateMatch && statusMatch && redirectedMatch;
    });
  }, [selectedState, txnSelectedStatus, transactionsData, isRedirectedChecked]);

  const filteredAqTransactionsData = useMemo(() => {
    return aqTransactionsData.filter((txn) => {
      let stateMatch = selectedState === "All" || txn.state === selectedState;

      if (selectedState === "Mismatches") {
        stateMatch =
          txn.state !== "Matched" &&
          (txn.state === "Not Found" ||
            txn.state === "Amount Mismatch" ||
            txn.state === "Status Mismatch");
      }

      const txnStatusGroup = getStatusGroup(txn.status);
      const statusMatch =
        !aqSelectedStatus || txnStatusGroup === aqSelectedStatus;

      return stateMatch && statusMatch;
    });
  }, [selectedState, aqSelectedStatus, aqTransactionsData]);

  const totalSuccessAmount = filteredTransactionsData
    .filter((txn) => (txn.status || "").toLowerCase() === "success")
    .reduce((sum, txn) => sum + parseFloat(txn.amount || 0), 0);

  const aqTotalSuccessAmount = filteredAqTransactionsData
    .filter((txn) => (txn.statusGroup || "").toLowerCase() === "success")
    .reduce((sum, txn) => sum + parseFloat(txn.amount || 0), 0);

  const handleSubmit = async () => {
    try {
      const response = await fetch("https://api.vancipay.com/api/v1/recon/rates", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setSubmitText("Submitted!");
        setTimeout(() => {
          setSubmitText("Submit");
        }, 1500);
      } else {
        setSubmitText("Not Submitted");
        setTimeout(() => {
          setSubmitText("Submit");
        }, 1500);
      }
    } catch (error) {
    }
  };

  const handleFetchReconciliation = async () => {
    const fromDate = `${fromDateInput} 00:00:00`;
    const toDate = `${toDateInput} 23:59:59`;
    setIsLoading(true);
    const payload = {
      fromDate,
      toDate,
      acquirer: selectedAquirer,
      fetchAcquirerIds: selectedAquirer === "Pagora" ? fetchAcquirerIds : false,
    };
    console.log('payload', payload)
    try {
      const response = await fetch("https://api.vancipay.com/api/v1/recon/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      const apiData = result.data || [];
      const reconId = result.id;

      if (apiData.length === 0) return;

      const updatedData = apiData.map((txn) => ({
        ...txn,
        state: "",
      }));

      setTransactionsData(updatedData);
      setisData(true);
      setSelectedState("All");

      if (reconId) {
        fetchRatesById(reconId);
      }
      setShouldGenerateReport(true);
    } catch (error) {
      console.error("Error creating reconciliation:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchRatesById = async (id) => {
    try {
      const response = await fetch(`https://api.vancipay.com/api/v1/recon/rates/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      });

      const result = await response.json();
      const data = result?.data;

      if (data) {
        setRates({
          mdr: parseFloat(data.mdr) || "",
          rr: parseFloat(data.rr) || "",
          app_fee: parseFloat(data.approval_fee) || "",
          dec_fee: parseFloat(data.decline_fee) || "",
          sett_fee: parseFloat(data.settlement_fee) || ""
        });
      } else {
        console.warn("No rates data found in response.");
      }
    } catch (err) {
      console.error("Failed to fetch rates by ID:", err);
    }
  };

  const handleDropdownClick = async (txnId, index) => {
    if (expandedRowIndex === index) {
      setExpandedRowIndex(null);
      return;
    }

    setTimeout(() => {
      setStatusDetails((prev) => ({
        ...prev,
        [txnId]: "Success",
      }));
      setExpandedRowIndex(index);
    }, 500);
  };

  const handleDelete = (txnId) => {
    setExpandedRowIndex(null);
    const updatedData = filteredTransactionsData.filter(txn => txn.transaction_id !== txnId);
    setTransactionsData(updatedData);
  };

  const getShiftHours = (acquirer) => {
    if (!acquirer) {
      console.error("Error: No acquirer selected");
      return 0;
    }
    switch (acquirer.toLowerCase()) {
      case "neonpay":
        return 0;
      case "pagora":
        return 8 * 60 * 60 * 1000 - 30 * 60 * 1000;
      default:
        console.error("Error: Unrecognized acquirer:", acquirer);
        return 0;
    }
  };

  const generateSettlementReport = useCallback(
    (data, acquirer) => {
      const report = {};
      const shiftInMs = getShiftHours(acquirer);
      data.forEach((txn) => {
        const txnDate = new Date(txn.transaction_date);
        const shiftedDateObj = new Date(Date.UTC(
          txnDate.getUTCFullYear(),
          txnDate.getUTCMonth(),
          txnDate.getUTCDate(),
          txnDate.getUTCHours(),
          txnDate.getUTCMinutes(),
          txnDate.getUTCSeconds(),
          txnDate.getUTCMilliseconds()
        ) + shiftInMs);
        const shiftedDate = shiftedDateObj.toISOString().split("T")[0];
        const amount = parseFloat(txn.amount);

        if (!report[shiftedDate]) {
          report[shiftedDate] = {
            date: shiftedDate,
            successCount: 0,
            failedCount: 0,
            totalSuccessAmount: 0,
          };
        }

        if (txn.status === "Success") {
          report[shiftedDate].successCount += 1;
          report[shiftedDate].totalSuccessAmount += amount;
        } else if (txn.status === "Failed") {
          report[shiftedDate].failedCount += 1;
        }
      });

      const finalReport = Object.values(report).map((row) => {
        const mdrAmount = +(row.totalSuccessAmount * (rates.mdr / 100)).toFixed(2);
        const appFee = +(row.successCount * rates.app_fee).toFixed(2);
        const decFee = +(row.failedCount * rates.dec_fee).toFixed(2);
        const rrAmount = +(row.totalSuccessAmount * (rates.rr / 100)).toFixed(2);
        const settlementAmount = +(
          row.totalSuccessAmount - (mdrAmount + appFee + decFee + rrAmount)
        ).toFixed(2);
        const settlementFee = +(settlementAmount * (rates.sett_fee / 100)).toFixed(2);
        const finalsettlementAmount = +(settlementAmount - settlementFee).toFixed(2);

        return {
          ...row,
          mdrAmount,
          appFee,
          decFee,
          rrAmount,
          settlementAmount,
          settlementFee,
          finalsettlementAmount,
        };
      });

      return finalReport;
    },
    [rates]
  );

  const handleGenerateReport = useCallback(() => {
    const report = generateSettlementReport(transactionsData, selectedAquirer);
    setSettlementReport(report);
  }, [transactionsData, generateSettlementReport, selectedAquirer]);

  useEffect(() => {
    if (shouldGenerateReport && transactionsData.length > 0) {
      handleGenerateReport();
      setShouldGenerateReport(false);
    }
  }, [transactionsData, handleGenerateReport, shouldGenerateReport]);

  function getStatusGroup(status) {
    const s = status?.toString().toLowerCase().trim();
    if (["success", "ok", "approved", "complete", "done"].includes(s)) {
      return "success";
    } else if (["fail", "failed", "declined", "timeout", "rejected", "error"].includes(s)) {
      return "fail";
    } else {
      return "other";
    }
  }

  const reconcileTransactions = () => {
    const normalizeAmount = (value) => {
      if (value === null || value === undefined) return 0;
      const cleaned = String(value).replace(/[^0-9.-]/g, "");
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : parseFloat(num.toFixed(2));
    };

    const aqMap = new Map();
    aqTransactionsData.forEach((txn) => {
      aqMap.set(txn.transaction_id, txn);
    });

    const updatedTransactions = transactionsData.map((txn) => {
      const match = aqMap.get(txn.transaction_id);
      if (!match) return { ...txn, state: "Not Found" };

      const amountMatch = normalizeAmount(txn.amount) === normalizeAmount(match.amount);
      const currencyMatch =
        String(txn.currency).trim().toUpperCase() === String(match.currency).trim().toUpperCase();

      const statusMatch =
        getStatusGroup(txn.status) === match.statusGroup;

      if (!statusMatch && !amountMatch && !currencyMatch) {
        return { ...txn, state: "Status Mismatch" };
      }

      if (!amountMatch || !currencyMatch) return { ...txn, state: "Amount Mismatch" };
      if (!statusMatch) return { ...txn, state: "Status Mismatch" };

      return { ...txn, state: "Matched" };
    });

    const txMap = new Map();
    transactionsData.forEach((txn) => {
      txMap.set(txn.transaction_id, txn);
    });

    const updatedAqTransactions = aqTransactionsData.map((txn) => {
      const match = txMap.get(txn.transaction_id);
      if (!match) return { ...txn, state: "Not Found" };

      const amountMatch = normalizeAmount(txn.amount) === normalizeAmount(match.amount);
      const currencyMatch =
        String(txn.currency).trim().toUpperCase() === String(match.currency).trim().toUpperCase();

      const statusMatch =
        txn.statusGroup === getStatusGroup(match.status);

      if (!statusMatch && !amountMatch && !currencyMatch) {
        return { ...txn, state: "Status Mismatch" };
      }

      if (!amountMatch || !currencyMatch) return { ...txn, state: "Amount Mismatch" };
      if (!statusMatch) return { ...txn, state: "Status Mismatch" };

      return { ...txn, state: "Matched" };
    });

    setTransactionsData(updatedTransactions);
    setAqTransactionsData(updatedAqTransactions);
    setIsReconClicked(true);
  };

  const markedData = filteredAqTransactionsData.map((row, i, arr) => {
    const isDuplicate = arr.some(
      (other, j) =>
        i !== j &&
        row.transaction_id === other.transaction_id &&
        row.amount === other.amount &&
        row.currency === other.currency &&
        row.status.toLowerCase() === other.status.toLowerCase()
    );
    return { ...row, isDuplicate };
  });

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const toggleDropdown = (field) => {
    setOpenDropdown(prev => (prev === field ? "" : field));
    setSearch(""); // reset search when open
  };

  // const handleCheckboxChange = (field, value) => {
  //   setMapping(prev => {
  //     const prevSelected = prev[field] || [];
  //     if (prevSelected.includes(value)) {
  //       return { ...prev, [field]: prevSelected.filter(v => v !== value) };
  //     } else {
  //       return { ...prev, [field]: [...prevSelected, value] };
  //     }
  //   });
  // };

  const handleSelectOption = (field, header) => {
    setMapping(prev => {
      const isMulti = multiSelectEnabled[field];
      const current = prev[field] || [];

      if (isMulti) {
        const newHeaders = current.includes(header)
          ? current.filter(h => h !== header)
          : [...current, header];
        return { ...prev, [field]: newHeaders };
      } else {
        return { ...prev, [field]: [header] };
      }
    });
  };


  const handleClearOption = () => {
    fileInputRef.current.value = "";
    setMapping({
      transaction_id: [],
      state: [],
      amount: [],
      currency: [],
      status: []
    });
  };

  const filteredHeaders = excelHeaders.filter(h => h.toLowerCase().includes(search.toLowerCase()));

  const handleopen = () => {
    setShowMappingBox(true);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    const data = await file.arrayBuffer();
    const wb = XLSX.read(data, { type: "array" });
    const rows = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 });
    setExcelHeaders(rows[0].map(h => h.toString().trim()));
  };

  const handleShow = () => {
    const file = fileInputRef.current.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const wb = XLSX.read(data, { type: "array" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const headers = json[0].map(h => h?.toString().trim());
      const rows = json.slice(1);

      const parsed = rows.map(row => {
        const getValue = (keys) => {
          if (!Array.isArray(keys)) return row[headers.indexOf(keys)];
          for (let k of keys) {
            const val = row[headers.indexOf(k)];
            if (val !== "" && val !== undefined && val !== null) return val;
          }
          return "";
        };

        const statusValue = getValue(mapping.status) || "";
        const statusGroup = getStatusGroup(statusValue);

        return {
          transaction_id: getValue(mapping.transaction_id)
            ?.toString()
            ?.replace(trimToRemove, ""),
          state: getValue(mapping.state),
          amount: getValue(mapping.amount),
          currency: getValue(mapping.currency),
          status: statusValue,
          statusGroup,
        };

      });

      setAqTransactionsData(parsed);
    };
    reader.readAsArrayBuffer(file);
    setisAqdata(true);
    setSelectedState("All");
    setShowMappingBox(false);
  };

  const hasTransactions = transactionsData.length > 0;
  const hasFilteredAqData = aqTransactionsData.length > 0;

  const handleExportReport = (selectedOption) => {
    if (!hasTransactions && !hasFilteredAqData) {
      alert("No report to export.");
      return;
    }

    const emptyRow = [];
    let aoaData = [];

    const headers = Object.keys(settlementReport[0] || {});
    const titleRow = ["Settlement Report"];
    const dataHeaders = headers;
    const dataRows = settlementReport.map(row => headers.map(h => row[h]));

    const totalsRow = headers.map((h, idx) => {
      if (idx === 0) return "Total";
      const value = totals[h];
      return typeof value === "number" ? value.toFixed(2) : "";
    });

    const matchedCount = transactionsData.filter(txn => txn.state === "Matched").length;
    const notFoundCount = transactionsData.filter(txn => txn.state === "Not Found").length;
    const amountMismatchCount = transactionsData.filter(txn => txn.state === "Amount Mismatch").length;
    const statusMismatchCount = transactionsData.filter(txn => txn.state === "Status Mismatch").length;

    const reconAccuracy =
      transactionsData.length > 0
        ? ((matchedCount / transactionsData.length) * 100).toFixed(2)
        : "0.00";

    const summaryHeaders = ["Summary", "Value"];
    const summaryData = [
      ["Total Final Settlement Amount", totalFinalSettlementAmount.toFixed(2)],
      ["Recon Accuracy", `${reconAccuracy}%`],
      ["Transactions Matched", matchedCount],
      ["Transactions Not Found", notFoundCount],
      ["Status Mismatched", statusMismatchCount],
      ["Amount Mismatched", amountMismatchCount],
    ];
    const flattenedSummaryData = summaryData.map(row => row);

    if (selectedOption === "Aquirer Report") {
      const markedHeaders = [
        "Transaction ID",
        "State",
        "Amount",
        "Applied Amount",
        "Currency",
        "Applied Currency",
        "Calculated Amount",
        "Calculated Currency",
        "Status"
      ];

      const markedRows = markedData.map(txn => [
        txn.transaction_id,
        txn.state,
        txn.originalAmount || "",
        txn.appliedAmount || "",
        txn.originalCurrency || "",
        txn.appliedCurrency || "",
        txn.rawAmount || "",
        txn.rawCurrency || "",
        txn.status || ""
      ]);
      aoaData = [markedHeaders, ...markedRows, emptyRow];

    } else if (selectedOption === "Centpays settlement") {
      aoaData = [titleRow, emptyRow, dataHeaders, ...dataRows, emptyRow, [...totalsRow]];

    } else if (selectedOption === "Settlement Report") {
      aoaData = [
        titleRow,
        emptyRow,
        dataHeaders,
        ...dataRows,
        emptyRow,
        [...totalsRow],
        emptyRow,
        summaryHeaders,
        ...flattenedSummaryData,
        emptyRow,
      ];
    }

    const worksheet = XLSX.utils.aoa_to_sheet(aoaData);
    const allRows = aoaData.filter(row => Array.isArray(row));

    const colWidths = headers.map((_, colIndex) => {
      let maxLength = 10;
      allRows.forEach(row => {
        const cell = row[colIndex];
        if (cell) {
          const cellLength = String(cell).length;
          maxLength = Math.max(maxLength, cellLength);
        }
      });
      return { wch: maxLength + 2 };
    });

    worksheet["!cols"] = colWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Settlement Report");

    XLSX.writeFile(workbook, "Settlement_Report.xlsx");
  };

  const handleExportSelection = (option) => {
    setSelectedExportOption(option);
    setExportDropdown(false);
    handleExportReport(option);
  };

  const totals = settlementReport.reduce(
    (acc, row) => ({
      totalSuccessAmount: acc.totalSuccessAmount + row.totalSuccessAmount,
      mdrAmount: acc.mdrAmount + row.mdrAmount,
      successCount: acc.successCount + row.successCount,
      appFee: acc.appFee + row.appFee,
      failedCount: acc.failedCount + row.failedCount,
      decFee: acc.decFee + row.decFee,
      rrAmount: acc.rrAmount + row.rrAmount,
      settlementAmount: acc.settlementAmount + row.settlementAmount,
      settlementFee: acc.settlementFee + row.settlementFee,
      finalsettlementAmount: acc.finalsettlementAmount + row.finalsettlementAmount,
    }),
    {
      totalSuccessAmount: 0,
      mdrAmount: 0,
      successCount: 0,
      appFee: 0,
      failedCount: 0,
      decFee: 0,
      rrAmount: 0,
      settlementAmount: 0,
      settlementFee: 0,
      finalsettlementAmount: 0,
    }
  );

  const renderDropdown = (isVisible, options, onSelect, onClose) =>
    isVisible && (
      <div className="dropdown-menu" ref={dropdownRef}>
        {options.map((opt) => (
          <div
            key={opt}
            className="dropdown-item flex justify-between items-center"
            onClick={() => {
              onSelect(opt);
              onClose();
            }}
            title={opt === "Pagora" ? "aquirerdata fetch" : ""}
          >
            <span>{opt}</span>
            {opt === "Pagora" && (
              <input
                type="checkbox"
                onClick={(e) => e.stopPropagation()}
                onChange={(e) => setFetchAcquirerIds(e.target.checked)}
                checked={fetchAcquirerIds}
                title="Fetch AcquirerIds"
              />
            )}
          </div>
        ))}
      </div>
    );

  const inputFields = [
    { name: "mdr", label: "MDR", percent: true },
    { name: "approval_fee", label: "Approve Fee", currency: true },
    { name: "decline_fee", label: "Decline Fee" },
    { name: "rr", label: "RR", percent: true },
    { name: "settlement_fee", label: "Settlement Fee", percent: true },
    { name: "password", label: "Password" },
  ];

  const selectConfigs = [
    {
      name: 'traffic_type',
      value: formData.traffic_type,
      options: [
        { label: 'Traffic', value: 'Currency' },
        { label: 'FTD', value: 'USD' },
        { label: 'STD', value: 'EUR' }
      ]
    },
    {
      name: 'currency',
      value: formData.currency,
      options: [
        { label: 'Currency', value: 'Currency' },
        { label: 'USD', value: 'USD' },
        { label: 'EUR', value: 'EUR' }
      ]
    }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      {!isAuthenticated && (
        <div className="login-modal-overlay">
          <div className="login-modal glassy">
            <h2>Login to Access Reconciliation</h2>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={loginData.email}
              onChange={handleLoginChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={loginData.password}
              onChange={handleLoginChange}
            />
            <button onClick={handleLogin}>Login</button>
            {loginError && <p className="error-text">{loginError}</p>}
          </div>
        </div>
      )}
      <div className={`main-page ${!isAuthenticated ? 'blurred' : ''}`}>
        {/* <div className="main-page"> */}
        <div className="header-tab flex">
          <img src={AxipaysLogo} alt="axipays-logo" className="logo" />
          <div className="flex">
            <h1>Profile</h1>
            <div className="button-div plus-btn" onClick={() => setShowModal(true)}>
              <span>+</span>
            </div>
            {showModal && (
              <div className="modal-overlay">
                <div className="modal-content glassy">
                  <h2>Acquirer Configuration</h2>
                  <select name="acquirer" value={formData.acquirer} onChange={handleChange}>
                    <option value="">Select Acquirer</option>
                    {aquirerOptions.map((item, idx) => (
                      <option key={idx} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                  <div className="flex">
                    {selectConfigs.map((config, idx) => (
                      <select
                        key={idx}
                        name={config.name}
                        value={config.value}
                        onChange={handleChange}
                      >
                        {config.options.map((opt, i) => (
                          <option key={i} value={opt.value}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    ))}
                  </div>

                  {inputFields.map(({ name, label, currency, percent }) => (
                    <div key={name}>
                      {/* <label>
                        {label} {currency ? `(${formData.currency})` : ""} {percent ? "(%)" : ""}
                      </label> */}
                      <input
                        type={label === "Password" ? "password" : "text"}
                        name={name}
                        value={formData[name]}
                        onChange={handleChange}
                        placeholder={`Enter ${label} ${currency ? `in ${formData.currency}` : percent ? "%" : ""}`}
                        autoComplete={label === "Password" ? "new-password" : "off"}
                      />
                    </div>
                  ))}

                  <div className="modal-actions">
                    <button onClick={handleSubmit}>{submitText}</button>
                    <button onClick={() => {
                      setShowModal(false);
                      setFormData({
                        acquirer: "",
                        currency: "",
                        traffic_type: "",
                        mdr: "",
                        approval_fee: "",
                        decline_fee: "",
                        rr: "",
                        settlement_fee: "",
                        password: ""
                      });
                    }}>Cancel</button>
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
        <div className="head-tab flex">
          <div className="flex">
            <h1>Bank Reconciliation</h1>
            <div onClick={handleRefresh} title="Refresh Page">
              <img src={refresh} alt="refresh" className="refresh-icon" />
            </div>
          </div>

          <div className="flex">
            <div className="export-btn relative">
              <div
                className="button-div download-button"
                onClick={() => {
                  if (exportOptions.length > 0) {
                    setExportDropdown((prev) => !prev);
                  }
                }}
              >
                <p>Export Settlements</p>
                <img src={download} alt="download" className="icon16" />
                {renderDropdown(exportDropdown, exportOptions, handleExportSelection, () => setExportDropdown(false))}
              </div>
            </div>
            <div className="relative">
              <input
                type="file"
                accept=".xlsx,.xls,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />

              <div className="button-div upload-button" onClick={handleopen}>
                <p>Select Excel</p>
              </div>

              {showMappingBox && (
                <div className="mapping-box">
                  <div className="mapping-box-header flex">
                    <span
                      className="close-icon relative"
                      onClick={() => setShowInfo(prev => !prev)}
                      title="How to use"
                    >
                      i
                    </span>
                    <span
                      className="close-icon"
                      onClick={() => {
                        setShowMappingBox(false);
                        setExcelHeaders([]);
                        setMapping({
                          transaction_id: [],
                          amount: [],
                          currency: [],
                          status: []
                        });
                        fileInputRef.current.value = "";
                      }}
                    >
                      &times;
                    </span>
                  </div>
                  {showInfo && (
                    <div className="mapping-instructions">
                      <p><strong>Process:</strong></p>
                      <ol>
                        <li>First, upload the Excel file using the button below.</li>
                        <li>After upload, headers will appear in the dropdowns.</li>
                        <li>To compare fields (e.g., “Applied Amount” vs “Amount”), enable multi-select using the checkbox.</li>
                        <li>Select headers in the order of preference. The first selected header will be used; if it's blank, the next one will be used as fallback.</li>
                        <li>You can use the trim input to strip unwanted text from the Transaction ID.</li>
                        <li>Click “Show” to render the mapped Excel data in your table.</li>
                      </ol>
                    </div>
                  )}
                  <label className="upload-label">Upload Excel</label>
                  <div className="flex">
                    <input
                      type="text"
                      className="trim-input"
                      value={fileInputRef.current?.files?.[0]?.name || ''}
                      placeholder="No file selected"
                      readOnly
                    />
                    <div className="button-div upload-button small" onClick={handleUploadClick}>
                      <p>upload</p>
                    </div>
                  </div>
                  {['transaction_id', 'amount', 'currency', 'status'].map(field => (
                    <div key={field} className="map-item">
                      <div className="multi-select-toggle flex">
                        <label>{field.replace('_', ' ')}</label>
                        <input
                          type="checkbox"
                          id={`multi-${field}`}
                          title="Allow Multiple Selection for Comparison"
                          checked={multiSelectEnabled[field]}
                          onChange={() =>
                            setMultiSelectEnabled(prev => ({
                              ...prev,
                              [field]: !prev[field]
                            }))
                          }
                        />
                      </div>

                      <div className="custom-dropdown">
                        <div
                          className={`dropdown-header ${!excelHeaders.length ? 'disabled-dropdown' : ''}`}
                          onClick={() => {
                            if (!excelHeaders.length) {
                              alert("Please upload an Excel file first.");
                              return;
                            }
                            toggleDropdown(field);
                          }}
                        >
                          {mapping[field]?.length ? mapping[field].join(', ') : "Select header(s)"}
                        </div>

                        {openDropdown === field && excelHeaders.length > 0 && (
                          <div className="dropdown-options" ref={dropdownRef}>
                            <input
                              className="trim-input"
                              placeholder="Search..."
                              value={search}
                              onChange={e => setSearch(e.target.value)}
                            />
                            <div className="dropdown-scroll">
                              {filteredHeaders.map(h => (
                                <label
                                  key={h}
                                  className="checkbox-option"
                                  onClick={e => {
                                    e.preventDefault();
                                    handleSelectOption(field, h);
                                    if (!multiSelectEnabled[field]) {
                                      setOpenDropdown(null);
                                    }
                                  }}
                                >
                                  {multiSelectEnabled[field] && (
                                    <input
                                      type="checkbox"
                                      checked={mapping[field]?.includes(h) || false}
                                      readOnly
                                    />
                                  )}
                                  <p>{h}</p>
                                </label>
                              ))}

                            </div>
                          </div>
                        )}

                      </div>

                      {field === "transaction_id" && (
                        <div className="trim-input-container">
                          <input
                            type="text"
                            placeholder="Remove text (e.g. va)"
                            value={txnIdTrimValue}
                            onChange={(e) => {
                              setTxnIdTrimValue(e.target.value);
                              setTrimToRemove("");
                            }}
                            className="trim-input"
                          />
                          <button
                            title="Save trim value"
                            onClick={() => setTrimToRemove(txnIdTrimValue)}
                            className="trim-icon-btn"
                          >
                            {trimToRemove === txnIdTrimValue ? '✅' : '🗑️'}
                          </button>
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="flex">
                    <button className="button-div upload-button show-button" onClick={handleShow}>
                      Show
                    </button>
                    <button className="button-div upload-button show-button" onClick={handleClearOption}>
                      Clear
                    </button>
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
        <div className="filter-tab flex">
          <div className="filter-tab-1 flex">
            <div className="date-filter flex">
              <div className="date-select flex">
                <p>From:</p>
                <div className="flex flex-col">
                  <input
                    type="date"
                    value={fromDateInput}
                    onChange={(e) => setFromDateInput(e.target.value)}
                  />
                </div>
              </div>
              <div className="date-select flex">
                <p>To:</p>
                <div className="flex flex-col">
                  <input
                    type="date"
                    value={toDateInput}
                    onChange={(e) => setToDateInput(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="acquirer-filter flex relative justify-between">
              <div
                className="flex items-center cursor-pointer justify-between"
                onClick={() => setAquirerDropdown((prev) => !prev)}
              >
                <p>{selectedAquirer || "Acquirer"}</p>
                <img src={arrowDropDownWhite} alt="arrow" className="icon20" />
              </div>

              {renderDropdown(aquirerDropdown, aquirerOptions, setSelectedAquirer, () => setAquirerDropdown(false))}
            </div>
            <div className="button-div upload-button" onClick={!isLoading ? handleFetchReconciliation : null}>
              <div className={isLoading ? "loader" : ""}></div> <p>Create</p>
            </div>

            <div className="button-div upload-button" onClick={handleClear}>
              <p>Clear</p>
            </div>

          </div>
          <div className="filter-tab-1 flex">
            {isAqdata && isData ? (
              <>
                <div className="states-filter flex relative">
                  <div className="selected-state flex">
                    <p className="text-sm">{selectedState || "All"}</p>
                    <img
                      src={close}
                      alt="close"
                      className="icon16 cursor-pointer"
                      onClick={() => setSelectedState("All")}
                    />
                  </div>
                  <div
                    className={`flex items-center cursor-pointer ${isReconClicked ? "" : "disabled"}`}
                    onClick={() => {
                      if (isReconClicked) setDropdownVisible((prev) => !prev);
                    }}
                    style={{
                      pointerEvents: isReconClicked ? "auto" : "none",
                      opacity: isReconClicked ? 1 : 0.5
                    }}
                  >
                    <p>States</p>
                    <img src={arrowDropDownWhite} alt="arrow" className="icon20 ml-2" />
                  </div>

                  {renderDropdown(dropdownVisible, statusOptions, setSelectedState, () => setDropdownVisible(false))}
                </div>
                <div
                  className="button-div upload-button"
                  onClick={reconcileTransactions}
                  title="Compare Reports"
                >
                  <p>Recon</p>{" "}
                </div>
              </>
            ) : null}

          </div>
        </div>
        {settlementReport.length > 0 && (
          <div className="main-tab">
            <h2>Daily Settlement Report</h2>
            <table>
              <thead>
                <tr>
                  {[
                    "Date", "Volume", "MDR", "App Count", "App Fee", "Dec Count", "Dec Fee",
                    "RR", "Pre Settlement Amount", "Settlement Fee", "Settlement Amount"
                  ].map((label, i) => <th key={i}>{label}</th>)}
                </tr>
              </thead>

              <tbody>
                {settlementReport.map((row, idx) => (
                  <tr key={idx}>
                    {[
                      row.date,
                      formatNumber(row.totalSuccessAmount.toFixed(2)),
                      formatNumber(row.mdrAmount.toFixed(2)),
                      row.successCount,
                      row.appFee.toFixed(2),
                      row.failedCount,
                      row.decFee.toFixed(2),
                      formatNumber(row.rrAmount.toFixed(2)),
                      formatNumber(row.settlementAmount.toFixed(2)),
                      row.settlementFee.toFixed(2),
                      formatNumber(row.finalsettlementAmount.toFixed(2))
                    ].map((cell, i) => <td key={i}>{cell}</td>)}
                  </tr>
                ))}
              </tbody>

              <tfoot>
                <tr className="settlement-total">
                  {[
                    "Total",
                    formatNumber(totals.totalSuccessAmount.toFixed(2)),
                    formatNumber(totals.mdrAmount.toFixed(2)),
                    totals.successCount,
                    totals.appFee.toFixed(2),
                    totals.failedCount,
                    totals.decFee.toFixed(2),
                    formatNumber(totals.rrAmount.toFixed(2)),
                    formatNumber(totals.settlementAmount.toFixed(2)),
                    totals.settlementFee.toFixed(2),
                    formatNumber(totals.finalsettlementAmount.toFixed(2))
                  ].map((cell, i) => (
                    <td key={i} className={i === 0 ? "totaltag" : ""}>{cell}</td>
                  ))}
                </tr>
              </tfoot>
            </table>
          </div>
        )}

        <div className="main-tab flex">
          <div className="report-section">
            <div className="flex"><div className="report-flex"><h2>Centpays Report</h2> <h4>Total Transactions:{isRedirectedChecked
              ? transactionsData.filter(txn => txn.is_redirected).length
              : transactionsData.length}</h4></div><div className="flex items-center gap-2">
                <label className="flex redirect-filter">
                  <input
                    type="checkbox"
                    checked={isRedirectedChecked}
                    onChange={() => setIsRedirectedChecked(!isRedirectedChecked)}
                  />
                  <h2 >Redirected Txns</h2>
                </label>
              </div></div>

            <div className="report-summary flex">
              <div>
                <h1>{
                  transactionsData.filter(txn => {
                    const matchRedirect = isRedirectedChecked ? txn.is_redirected : true;
                    const matchStatus = txnSelectedStatus ? txn.status === txnSelectedStatus : true;
                    return matchRedirect && matchStatus;
                  }).length
                }</h1>
                <p>Total {txnSelectedStatus === "" ? "Transactions" : txnSelectedStatus}</p>
              </div>
              <div>
                <h1>${formatNumber(totalSuccessAmount.toFixed(2))}</h1>
                <p>Total Success Volume</p>
              </div>
              <div>
                <h1>
                  {selectedState === "All"
                    ? filteredTransactionsData.filter((txn) =>
                      ["Matched", "Amount Mismatch", "Status Mismatch"].includes(txn.state)
                    ).length
                    : filteredTransactionsData.filter((txn) => txn.state).length}
                </h1>
                <p>Total {selectedState === "All" ? "Match" : selectedState} </p>
              </div>
              <div>
                <h1>
                  {filteredTransactionsData.length > 0
                    ? (
                      (
                        selectedState === "All"
                          ? filteredTransactionsData.filter((txn) =>
                            ["Matched", "Amount Mismatch", "Status Mismatch"].includes(txn.state)
                          ).length
                          : filteredTransactionsData.filter((txn) => txn.state).length
                      ) /
                      transactionsData.filter(txn => {
                        const matchRedirect = isRedirectedChecked ? txn.is_redirected : true;
                        const matchStatus = txnSelectedStatus ? txn.status === txnSelectedStatus : true;
                        return matchRedirect && matchStatus;
                      }).length *
                      100
                    ).toFixed(2)
                    : 0}
                  %

                </h1>
                <p>{selectedState === "All" ? "Match" : selectedState} %</p>
              </div>
            </div>
            <div className="report-table">
              <table>
                <thead>
                  <th>
                    <input type="checkbox" className="checkboxshift"></input>
                  </th>
                  <th>Transaction Id</th>
                  <th>State</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th><div className="status-head">
                    Status
                    <input
                      type="checkbox"
                      checked={txnSelectedStatus !== ""}
                      onChange={() => {
                        const statusOptions = ["Success", "Failed", "In Progress", ""];
                        const currentIndex = statusOptions.indexOf(txnSelectedStatus);
                        const nextStatus = statusOptions[(currentIndex + 1) % statusOptions.length];
                        setTxnSelectedStatus(nextStatus);
                      }}
                    />

                  </div></th>
                </thead>
                <tbody>
                  {filteredTransactionsData.map((txn, index) => (
                    <React.Fragment key={index}>
                      <tr>
                        <td><input type="checkbox" className="checkboxshift" /></td>
                        <td>
                          {(txn.transaction_id?.match(/.{1,31}/g) || []).join("\n")}
                        </td>
                        <td>
                          <p className={`state-cell ${txn.state === "Matched"
                            ? "matched"
                            : txn.state === "Amount Mismatch"
                              ? "amount-mismatch"
                              : txn.state === "Status Mismatch"
                                ? "status-mismatch"
                                : "missing"
                            }`}>
                            {txn.state}
                          </p>
                        </td>
                        <td>{txn.amount}</td>
                        <td>{txn.currency}</td>
                        <td>
                          <div className="status-div">
                            <div
                              className={`status-cell ${txn.status === "Success"
                                ? "success"
                                : txn.status === "In Progress"
                                  ? "inprogress"
                                  : "failed"
                                }`}
                            ></div>
                            {txn.status}
                            <img src={arrowDropDownWhite} alt="arrow" className="icon20 expand-row" onClick={() => handleDropdownClick(txn.transaction_id, index)} />
                          </div>
                        </td>
                      </tr>

                      {expandedRowIndex === index && (
                        <tr className="expanded-row">
                          <td colSpan="6">
                            <div className="dropdown-content">
                              <p>Status Details: {statusDetails[txn.transaction_id]}</p>
                              <button className="delete-btn" onClick={() => handleDelete(txn.transaction_id)}>Delete</button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
          <div className="report-section">
            <div className="report-flex">
              <h2>Acquirer Report</h2>
              <h4>Total Transactions:
                {aqTransactionsData.length}</h4>
            </div>
            <div className="report-summary flex">
              <div>
                <h1>{
                  aqTransactionsData.filter(txn => {
                    const matchStatus = aqSelectedStatus ? txn.statusGroup === aqSelectedStatus : true;
                    return matchStatus;
                  }).length}</h1>
                <p>Total {aqSelectedStatus === "" ? "Transaction" : aqSelectedStatus}</p>
              </div>
              <div>
                <h1>${formatNumber(aqTotalSuccessAmount.toFixed(2))}</h1>
                <p>Total Success Volume</p>
              </div>
              <div>
                <h1>
                  {selectedState === "All"
                    ? filteredAqTransactionsData.filter((txn) =>
                      ["Matched", "Amount Mismatch", "Status Mismatch"].includes(txn.state)
                    ).length
                    : filteredAqTransactionsData.filter((txn) => txn.state).length}
                </h1>
                <p>Total {selectedState === "All" ? "Match" : selectedState} </p>
              </div>
              <div>
                <h1>
                  {
                    (() => {
                      const totalSelectedStatusCount = aqTransactionsData.filter(txn => {
                        const matchStatus = aqSelectedStatus ? txn.statusGroup === aqSelectedStatus : true;
                        return matchStatus;
                      }).length;

                      const matchedCount = selectedState === "All"
                        ? filteredAqTransactionsData.filter(txn =>
                          ["Matched", "Amount Mismatch", "Status Mismatch"].includes(txn.state)
                        ).length
                        : filteredAqTransactionsData.filter(txn => txn.state === selectedState).length;

                      return totalSelectedStatusCount > 0
                        ? ((matchedCount / totalSelectedStatusCount) * 100).toFixed(2)
                        : "0.00";
                    })()
                  }%
                </h1>
                <p>{selectedState === "All" ? "Match" : selectedState} %</p>
              </div>
            </div>
            <div className="report-table">
              <table>
                <thead>
                  <th>
                    <input type="checkbox" className="checkboxshift"></input>
                  </th>
                  <th>Transaction Id</th>
                  <th>State</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th><div className="status-head">
                    Status
                    <input
                      type="checkbox"
                      checked={aqSelectedStatus !== ""}
                      onChange={() => {
                        const statusOptions = ["success", "fail", ""];
                        const currentIndex = statusOptions.indexOf(aqSelectedStatus);
                        const nextStatus = statusOptions[(currentIndex + 1) % statusOptions.length];
                        setAqSelectedStatus(nextStatus);
                      }
                      }
                    />

                  </div></th>
                </thead>
                <tbody className="scrollable-tbody">
                  {markedData.map((txn, index) => (
                    <tr key={index} className={txn.isDuplicate ? "duplicate-row" : ""}>
                      <td>
                        <input type="checkbox" className="checkboxshift" />
                      </td>
                      <td>{txn.transaction_id}</td>
                      <td>
                        <p
                          className={`state-cell ${txn.state === "Matched"
                            ? "matched"
                            : txn.state === "Amount Mismatch"
                              ? "amount-mismatch"
                              : txn.state === "Status Mismatch"
                                ? "status-mismatch"
                                : txn.state === "Not Found"
                                  ? "missing"
                                  : "missing"
                            }`}
                        >
                          {txn.state}
                        </p>
                      </td>
                      <td>{txn.amount}</td>
                      <td>{txn.currency}</td>
                      <td>
                        <div className="status-div">
                          <div
                            className={`status-cell ${txn.status?.toLowerCase() === "in progress"
                              ? "inprogress"
                              : txn.statusGroup === "success"
                                ? "success"
                                : txn.statusGroup === "fail"
                                  ? "failed"
                                  : "other"
                              }`}
                          ></div>
                          {txn.status}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reconciliation;
